export const data = [

    {
        name: 'Domnic Harris',
        designation: 'Android Developer',
        image: 'http://via.placeholder.com/256x256',
        description: "All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet"
    },
    {
        name: 'Garry Sobars',
        designation: 'React Developer',
        image: 'http://via.placeholder.com/256x256',
        description: "It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable."
    },
    {
        name: 'Stella Johnson',
        designation: 'Designer',
        image: 'http://via.placeholder.com/256x256',
        description: "The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
    }, {
        name: 'John Smith',
        designation: 'BDM',
        image: 'http://via.placeholder.com/256x256',
        description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum."
    },
    {
        name: 'Alex Dolgove',
        designation: 'Actor',
        image: 'http://via.placeholder.com/256x256',
        description: "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' "
    },
    {
        name: 'Domnic Brown',
        designation: 'Singer',
        image: 'http://via.placeholder.com/256x256',
        description: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable."
    },
];


// WEBPACK FOOTER //
// ./app/routes/customViews/routes/data.js